import { render, staticRenderFns } from "./HasChildrenModal.vue?vue&type=template&id=b50735f0&scoped=true&"
import script from "./HasChildrenModal.vue?vue&type=script&lang=js&"
export * from "./HasChildrenModal.vue?vue&type=script&lang=js&"
import style0 from "./HasChildrenModal.vue?vue&type=style&index=0&id=b50735f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50735f0",
  null
  
)

export default component.exports